import { useQuery } from "@apollo/client";

import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

import { InvoiceForPeriodDocument } from "./useInvoiceForPeriod.generated";

export function useInvoiceForPeriod(invoiceId: string) {
    const { client } = useRequireCurrentClient();

    const { data, loading, error } = useQuery(InvoiceForPeriodDocument, {
        variables: { invoiceId, clientId: client.id },
    });

    return { loading, error, data: data?.invoiceForPeriod };
}
